<template>
	<div>
		<div class="content-header">
			<ol class="breadcrumb">
				<li>
					<router-link :to="{ name: 'goodsList'}">
						商品列表
					</router-link>
				</li>
				<li class="active">添加/更新</li>
			</ol>
		</div>
		<div class="content-from">
			<el-form ref="formName" :model="saveModel" :rules="rules" label-width="100px" style="width:100%;margin:0 auto;">
				<el-form-item label="一级分类:">
					<el-select clearable v-model="goodsTypePlatformIdOne" @change="goodsTypePlatformOneChange">
						<el-option v-for="item in goodsTypePlatformOnes" :key="item.name" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="二级分类:">
					<el-select clearable v-model="goodsTypePlatformIdTwo">
						<el-option v-for="item in goodsTypePlatformTwos" :key="item.name" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称:" prop="name">
					<el-input v-model="saveModel.name" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="简要描述:" prop="briefRemark">
					<el-input v-model="saveModel.briefRemark" placeholder="请输入简要描述"></el-input>
				</el-form-item>
				<el-form-item label="同城显示:" prop="freightFree">
					<el-switch v-model="saveModel.isCity" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="是否包邮:" prop="freightFree">
					<el-select clearable v-model="saveModel.freightFree">
						<el-option v-for="(item,index) in freightFrees" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品性质:" prop="upgrade">
					<el-select clearable v-model="saveModel.upgrade">
						<el-option v-for="(item,index) in upgrades" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品重量(KG):" prop="weight" v-if="spaceType=='SOLID'">
					<el-input type="number" v-model="saveModel.weight" placeholder="请输入商品重量"></el-input>
				</el-form-item>
				<el-form-item label="是否自动发货:" prop="autoSend" v-if="spaceType=='VIRTUAL'">
					<el-select clearable v-model="saveModel.autoSend">
						<el-option v-for="(item,index) in autoSends" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="发货内容详情:" prop="sendContent" v-if="spaceType=='VIRTUAL'">
					<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="saveModel.sendContent" />
				</el-form-item>
				<el-form-item label="选择仓库:">
					<el-select clearable v-model="saveModel.sellerUserId" >
						<el-option v-for="item in sellers" :key="item.name" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品规格:">
					<div class="col-md-10">
						<div class="row">
							<div class="col-sm-3">
								名称
							</div>
							<div class="col-sm-2">
								单价
							</div>
							<div class="col-sm-2">
								原价
							</div>
							<div class="col-sm-2">
								成本价
							</div>
							<div class="col-sm-2">
								美肤达人分佣
							</div>
							<div class="col-sm-2">
								美肤总监分佣
							</div>
							<div class="col-sm-2" style="width: 25%;">
								购买人的分佣（输入的金额将会折算成积分）
							</div>
							<div class="col-sm-1">
								<a href="javascript: void(0);" @click="addGoodsPrice">添加</a>
							</div>
						</div>
						<div v-for="(goodsPrice, index) in goodsPrices" :key="index" class="row">
							<div class="col-sm-3">
								<input type="text" class="form-control" v-model="goodsPrice.name" placeholder="请输入规格名称">
							</div>
							<div class="col-sm-2">
								<input type="number" class="form-control" v-model="goodsPrice.price" placeholder="请输入单价" name="price">
							</div>
							<div class="col-sm-2">
								<input type="number" class="form-control" v-model="goodsPrice.originalPrice" placeholder="请输入原价" name="originalPrice">
							</div>
							<div class="col-sm-2">
								<input type="number" class="form-control" v-model="goodsPrice.costPrice" placeholder="请输入成本价" name="costPrice">
							</div>
							<div class="col-sm-2">
								<input type="number" class="form-control" v-model="goodsPrice.anchorPrice" placeholder="请输入美肤达人分佣" name="anchorPrice">
							</div>
							<div class="col-sm-2">
								<input type="number" class="form-control" v-model="goodsPrice.supplierPrice" placeholder="请输入美肤总监分佣" name="supplierPrice">
							</div>
							<div class="col-sm-2">
								<input type="number" class="form-control" v-model="goodsPrice.shareholderPrice" placeholder="请输入购买人的分佣（输入的金额将会折算成积分）" name="shareholderPrice">
							</div>

							<div class="col-sm-1">
								<a href="javascript: void(0);" @click="deleteGoodsPrice(index)">删除</a>
							</div>
						</div>
					</div>
				</el-form-item>
				<!--<el-form-item label="计费类型:" prop="feeType">
					<el-select clearable v-model="saveModel.feeType">
						<el-option v-for="item in feeTypes" :key="item.name" :label="item.label" :value="item.name"></el-option>
					</el-select>
				</el-form-item>-->
				<!-- <el-form-item label="参数设置:">
					<el-button type="primary" size="mini" @click="addPropertyClickFun">添加属性</el-button>
				</el-form-item>
				<el-form-item v-for="(property, propertyIndex) in properties" :key="propertyIndex">
					<div class="col-sm-8 row property-box">
						<input type="text" v-model="property.name" class="form-control" placeholder="请输入属性名称" />
					</div>
					<div class="col-sm-8 row property-box">
						<div v-for="(item, itemIndex) in property.items" :key="itemIndex" class="col-sm-2  can-shu">
							<input type="text" v-model="item.name" class="form-control" />
							<el-button size="mini" @click="deletePropertyItemClickFun(propertyIndex, itemIndex)">
								删除参数
							</el-button>
						</div>
					</div>
					<div class="cao-zuo">
						<el-button size="mini" @click="addPropertyItemClickFun(propertyIndex)">添加参数</el-button>
						<el-button size="mini" @click="deletePropertyClickFun(propertyIndex)">删除属性</el-button>
					</div>
				</el-form-item> -->
				<el-form-item label="库存:" prop="stockAmount">
					<el-input v-model="saveModel.stockAmount" placeholder="请输入库存"></el-input>
				</el-form-item>
				<el-form-item label="商品主图（尺寸238*238）:">
					<Upload :uploadData="uploadData" ref="goodsLogo"></Upload>
				</el-form-item>
        <el-form-item label="商品海报图（尺寸480*480）:">
          <Upload :uploadData="uploadData" ref="goodsPoster"></Upload>
        </el-form-item>
				<el-form-item label="相册图片(尺寸828*828)：">
					<Upload :uploadData="uploadData" ref="goodsAttach" :uploadType="'Array'" :businessId="goodsId"></Upload>
				</el-form-item>
				<el-form-item label="详细说明:" prop="sendContent">
					<UEditor :content="ueditorContent" ref="ueditor"></UEditor>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="saveGoods('formName')">确认</el-button>
					<el-button size="small" @click="resetForm('formName')">重置</el-button>
					<el-button size="small" @click="$router.back(-1)">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
	import UEditor from '@/components/ueditor.vue';
	import Upload from '@/components/upload.vue';
	export default {
		components: {
			UEditor,
			Upload
		},
		data() {
			return {
				goodsTypePlatformIdOne: '',
				goodsTypePlatformOnes: [],
				goodsTypePlatformIdTwo: '',
				goodsTypePlatformTwos: [],

				goodsTypeSellerIdOne: '',
				goodsTypeSellerOnes: [],
				goodsTypeSellerIdTwo: '',
				goodsTypeSellerTwos: [],

				goodsTypes: [],

				goodsId: '',
				saveModel: {
					spaceType: 'SOLID',
					feeType: 'COMMON',
					autoSend: 1,
					freightFree: 1,
					upgrade: 0,
					attaches: [],
					iconPath: null
				},
				uploadData: {
					folder: '',
					fileNamePre: 'goods',
				},
				properties: [],
				serverUrl: '',

				assetTypes: [],
				feeTypes: [],

				goodsPrices: [],

				spaceType: '',
				spaceTypeMap: {},

				ueditorContent: '',
				saleStatus: '',
				upgrades: [{
					label: '普通商品',
					value: 0
				}, {
					label: '升级商品',
					value: 1
				}],
				freightFrees: [{
					label: '是',
					value: 1
				}, {
					label: '否',
					value: 0
				}],
				autoSends: [{
					label: '是',
					value: 1
				}, {
					label: '否',
					value: 0
				}],
				rules: {
					name: [{
						required: true,
						message: "请输入商品名称",
						trigger: "blur"
					}],
					freightFree: [{
						required: true,
						message: "请选择邮费配置",
						trigger: "blur"
					}],
					assetType: [{
						required: true,
						message: "请选择支付方式",
						trigger: "blur"
					}],
					stockAmount: [{
						required: true,
						message: "请输入库存",
						trigger: "blur"
					}],
				},
				sellers:[],
			}
		},
		mounted() {
			var _this = this;
			_this.serverUrl=config.hostUrl;
			_this.spaceType = _this.$route.query.spaceType;
			_this.saleStatus = _this.$route.query.saleStatus;

			_this.goodsId = _this.$route.query.goodsId;

			if (_this.goodsId) {
				_this.detailGoods();
				_this.findGoodsProperty();
				_this.findGoodsPrice();
				_this.findGoodsType();
				_this.findGoodsCount();
			} else {
				_this.addGoodsPrice();
				_this.addPropertyClickFun()
			}
			_this.findGoodsTypePlatformOne();
			_this.findGoodsTypeSellerOne();
			_this.findSellers();
		},
		methods: {
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			findGoodsTypePlatformOne() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goodsType/pageGoodsTypeByManager',
					data: {
						scope: 'PLATFORM',
						level: 1
					},
					success: function(response) {
						_this.goodsTypePlatformOnes = response.items || [];
					}
				});
			},
			findSellers() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'seller/pageSeller',
					data: {
						limit: -1,
					},
					success: function(response) {
						_this.sellers = response.items || [];
					}
				});
			},
			goodsTypePlatformOneChange() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goodsType/pageGoodsTypeByManager',
					data: {
						scope: 'PLATFORM',
						parentTypeId: _this.goodsTypePlatformIdOne
					},
					success: function(response) {
						_this.goodsTypePlatformTwos = response.items;
					}
				});
			},
			findGoodsTypeSellerOne() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goodsType/pageGoodsTypeBySeller',
					data: {
						level: 1
					},
					success: function(response) {
						_this.goodsTypeSellerOnes = response.items;
					}
				});
			},
			goodsTypeSellerOneChange() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goodsType/pageGoodsTypeBySeller',
					data: {
						parentTypeId: _this.goodsTypeSellerIdOne
					},
					success: function(response) {
						_this.goodsTypeSellerTwos = response.items;
					}
				});
			},
			detailGoods() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goods/detailGoods',
					data: {
						goodsId: _this.goodsId
					},
					success: function(response) {
						_this.saveModel = response.item;
						_this.spaceType = _this.saveModel.spaceType;
						_this.ueditorContent = _this.saveModel.remark;
						_this.$refs.goodsLogo.loadIconPath(response.item.iconPath);
            _this.$refs.goodsPoster.loadIconPath(response.item.posterIconPath);
					}
				});
			},
			findGoodsProperty() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goodsProperty/findGoodsPropertyByGoodsId',
					data: {
						goodsId: _this.goodsId
					},
					success: function(response) {
						_this.properties = response.items || [];
					}
				});
			},
			addPropertyClickFun() {
				var _this = this;
				_this.properties.push({
					name: '',
					items: [{
						name: ''
					}]
				});
			},
			addPropertyItemClickFun(index) {
				var _this = this;
				_this.properties[index].items.push({
					name: ''
				});
			},
			deletePropertyClickFun(index) {
				var _this = this;
				_this.properties.splice(index, 1);
			},
			deletePropertyItemClickFun(propertyIndex, itemIndex) {
				var _this = this;
				_this.properties[propertyIndex].items.splice(itemIndex, 1);
			},
			saveGoods(formName) {
				var _this = this;
				_this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.saveModel.iconPath = _this.$refs.goodsLogo.getIconPath();
						_this.saveModel.posterIconPath = _this.$refs.goodsPoster.getIconPath();
						_this.saveModel.attaches = _this.$refs.goodsAttach.getIconPath();
						if (_this.saveGoodsCheck()) {
							if ('WAREGOUSE' == _this.saleStatus) {
								_this.saveModel.saleStatus = 'WAREGOUSE';
							} else {
								_this.saveModel.saleStatus = 'ONLINE';
							}
							_this.saveModel.goodsPrices = _this.goodsPrices;
							_this.saveModel.properties = _this.properties;
							var goodsTypeIds = [];
							goodsTypeIds.push(_this.goodsTypePlatformIdOne);
							goodsTypeIds.push(_this.goodsTypePlatformIdTwo);
							goodsTypeIds.push(_this.goodsTypeSellerIdOne);
							goodsTypeIds.push(_this.goodsTypeSellerIdTwo);
							_this.saveModel.goodsTypeIds = goodsTypeIds;

							this.getContent();
							_this.$common.my_ajax({
								url: 'goods/saveGoods',
								contentType: 'application/json',
								data: _this.saveModel,
								success: function(response) {
									_this.$message({
										message: '保存成功',
										type: 'success',
										duration: 1000,
										onClose: function() {
											_this.$router.back(-1);
										}
									});
								}
							});
						}
					} else {
						return false;
					}
				});
			},
			saveGoodsCheck() {
				var _this = this;
				if (!_this.goodsTypePlatformIdOne) {
					_this.$message({
						showClose: true,
						message: '请选择平台一级分类',
						duration: 1000,
						type: 'error',
					});
					return false;
				}

				if (!_this.goodsTypePlatformIdTwo && ('2d81b904-d094-411c-be49-64784d2eca81' != _this.goodsTypePlatformIdOne &&
						'dd816a6d-8299-40f1-8cce-a71abc0249da' != _this.goodsTypePlatformIdOne)) {
					_this.$message({
						showClose: true,
						message: '请选择平台二级分类',
						duration: 1000,
						type: 'error',
					});
					return false;
				}
				if (_this.goodsPrices.length == 0) {
					_this.$message({
						showClose: true,
						message: '请填写商品规格',
						duration: 1000,
						type: 'error',
					});
					return false;
				}

				if (!_this.saveModel.iconPath) {
					_this.$message({
						showClose: true,
						message: '请上传商品主图',
						duration: 1000,
						type: 'error',
					});
					return false;
				}
				if (_this.saveModel.attaches.length == 0) {
					_this.$message({
						showClose: true,
						message: '请上传商品相册',
						duration: 1000,
						type: 'error',
					});
					return false;
				}
				return true;
			},
			gotoList() {
				this.$router.push({
					name: 'goodsList',
					query: {
						spaceType: this.spaceType
					}
				});
			},
			findGoodsPrice() {
				var _this = this;
				if (_this.goodsId) {
					_this.$common.my_ajax({
						url: 'goodsPrice/pageGoodsPrice',
						data: {
							goodsId: _this.goodsId
						},
						success: function(response) {
							_this.goodsPrices = response.items;
							if (0 == _this.goodsPrices.length) {
								_this.goodsPrices = [{}];
							}
						}
					});
				} else {
					_this.goodsPrices = [{}];
				}
			},
			deleteGoodsPrice(_index) {
				this.goodsPrices.splice(_index, 1);
			},
			addGoodsPrice() {
				this.goodsPrices.push({
					name: '',
					price: 0,
					originalPrice: 0,
					costPrice: 0,
				});
			},

			findGoodsType() {
				var _this = this;
				if (_this.goodsId) {
					_this.$common.my_ajax({
						url: 'goodsTypeRelation/findByGoodsId',
						data: {
							goodsId: _this.goodsId
						},
						success: function(response) {
							_this.goodsTypes = response.items;
							for (var i in _this.goodsTypes) {
								var goodsType = _this.goodsTypes[i];
								if (goodsType.scope == 'PLATFORM' && goodsType.level == 1) {
									_this.goodsTypePlatformIdOne = goodsType.id;
									_this.goodsTypePlatformOneChange();
								} else if (goodsType.scope == 'PLATFORM' && goodsType.level == 2) {
									_this.goodsTypePlatformIdTwo = goodsType.id;
								} else if (goodsType.scope == 'SELLER' && goodsType.level == 1) {
									_this.goodsTypeSellerIdOne = goodsType.id;
									_this.goodsTypeSellerOneChange();
								} else if (goodsType.scope == 'SELLER' && goodsType.level == 2) {
									_this.goodsTypeSellerIdTwo = goodsType.id;
								}
							}
						}
					});
				}
			},
			findGoodsCount() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'goodsCount/findByGoodsId',
					data: {
						goodsId: _this.goodsId
					},
					success: function(response) {
						_this.$set(_this.saveModel, 'stockAmount', response.item.stockAmount);
					}
				});
			},
			getContent: function() {
				var _this = this;
				let content = _this.$refs.ueditor.getUEContent();
				_this.saveModel.remark = content;
				console.log(content);
			}
		},
	}
</script>

<style scoped>
	.col-sm-1 {
		width: 7%;
	}
	.col-sm-2 {
		width: 10%;
	}
	.col-sm-3 {
		width: 15%;
	}
	.property-box {
		width: auto !important;
		max-width: 678px;
	}

	.can-shu {
		width: 160px;
		margin-bottom: 20px;
	}
</style>
